import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=2ff04859&scoped=true&"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&id=2ff04859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff04859",
  null
  
)

export default component.exports